var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "v-button-component",
      class: { small: _vm.small, cancel: _vm.cancel },
      style: _vm.buttonComponentStyle,
    },
    [
      _c(
        "button",
        {
          ref: "button",
          staticClass: "v-button",
          class: _vm.color,
          style: _vm.buttonStyle,
          on: {
            click: function ($event) {
              return _vm.$emit("click")
            },
          },
        },
        [
          _vm.icon
            ? _c("div", { staticClass: "v-button-icon", style: _vm.iconStyle })
            : _vm._e(),
          _vm._t("default"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }